import { useEffect, useRef } from 'react';

export function useMfaDialog(onCancel: () => void, busy = false) {
    const panel = useRef<HTMLElement>(null);
    const cancel = useRef(onCancel);
    const blocked = useRef(busy);
    cancel.current = onCancel;
    blocked.current = busy;
    useEffect(() => {
        const previous = document.activeElement as HTMLElement | null;
        const handleKey = (event: KeyboardEvent) => {
            const dialogs = document.querySelectorAll('[aria-modal="true"]');
            if (dialogs[dialogs.length - 1] !== panel.current)
                return;
            if (event.key === 'Escape' && !blocked.current) {
                event.preventDefault();
                event.stopImmediatePropagation();
                cancel.current();
            }
            if (event.key !== 'Tab')
                return;
            const controls = Array.from(panel.current!.querySelectorAll<HTMLElement>('button:not(:disabled), input:not(:disabled), select:not(:disabled), textarea:not(:disabled), a[href], iframe, [tabindex="0"]'))
                .filter(element => element.getClientRects().length > 0);
            const target = event.shiftKey ? controls[controls.length - 1] : controls[0];
            if (!panel.current!.contains(document.activeElement) || document.activeElement === (event.shiftKey ? controls[0] : controls[controls.length - 1])) {
                event.preventDefault();
                target?.focus();
            }
        };
        window.addEventListener('keydown', handleKey);
        return () => { window.removeEventListener('keydown', handleKey); if (previous?.isConnected) previous.focus(); };
    }, []);
    return panel;
}
